import React, { Component } from 'react';
import { Link } from 'gatsby';
import Particles from 'react-particles-js';
import { symplaClick, regulamentoClick } from '../../analytics/events';
import agritechLogoIcone from '../../assets/images/agritech_logo_mini.png';
import './styles.scss';

export default class Header extends Component {
  componentDidMount() {
    this.getDeviceWidth();

    window.addEventListener('resize', this.getDeviceWidth);

    window.addEventListener('scroll', () => {
      if (Math.round(window.scrollY) > window.innerHeight) {
        document.querySelector('.header').classList.add('sticky');
      } else {
        document.querySelector('.header').classList.remove('sticky');
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize');
    window.removeEventListener('scroll');
  }

  getDeviceWidth = () => {
    this.setState({ windowWidth: window.innerWidth });
  }

  state = {
    windowWidth: 0
  }

  render() {
    const { menuLinks } = this.props;
    const { windowWidth } = this.state;

    return (
      <React.Fragment>
        <section id="banner">
          <Particles
            className="particles"
            params={{
              particles: {
                number: {
                  value: windowWidth <= 1000
                    ? windowWidth / 20
                    : windowWidth / 25
                },
                size: {
                  value: 1
                }
              },
              interactivity: {
                events: {
                  onhover: {
                    enable: true,
                    mode: 'repulse'
                  }
                }
              }
            }}
          />
          <div className="principal">
            <header>
              <div>
                <img alt="AgriTech - UniLaSalle/Lucas" src={agritechLogoIcone} />
              </div>
                <h2 style={{ margin: 0 }}>AgriTech - UniLasalle/Lucas</h2>
                <h4>Hackathon de Agronegócio</h4>
                {/* <span>de 13 a 15 de março de 2020</span>
                <br />
                <span>em UniLasalle - Lucas do Rio Verde/MT</span> */}
              </header>
              <div style={{ border: '2px solid grey', borderRadius: 20, padding: '20px 10px 5px 10px' }}>
                <span style={{ fontWeight: 'bolder' }}>R$ </span>
                <span style={{ fontSize: '3rem', fontWeight: 'bold' }}>5.000,00</span>
                <br />
                <em style={{ fontSize: '1.5rem' }}>em premiações</em>
              </div>
              <div>
                <strong style={{ color: '#c81912', fontSize: 24, fontWeight: 'bold' }}>COMUNIDADO</strong>
                <p style={{ fontSize: 16 }}>
                  Alteração da forma de premiação:
                  <br />
                  leia na íntegra o documento <a href="https://storage.googleapis.com/hackathonagritech.appspot.com/premiacao_comunicado_hackathon_agritech.pdf" target="_blank">clicando aqui</a>.
                </p>
              </div>
              {/* <div>
                <button className="participar" onClick={symplaClick} type="button">Adquirir Ingresso</button>
              </div> */}
          </div>
        </section>
        <header className="header">
          <h1>
            <img
              alt="AgriTech - UniLaSalle/Lucas"
              height="40px"
              src={agritechLogoIcone}
            />
          </h1>
          <nav style={{ display: 'flex', alignItems: 'center' }}>
            <Link
              className="nav-link"
              style={{
                animation: 0,
                marginTop: 2,
                padding: '5px 10px'
              }}
              onClick={regulamentoClick}
              type="button"
            >Regulamento</Link>
            {/* {
              menuLinks.map((menuLink) => {
                const {
                  cl,
                  internal,
                  link,
                  name
                } = menuLink;
                if (link !== '/') {
                  if (internal) return (<Link className="nav-link" to={link}>{name}</Link>);
                  if (!internal) return (
                    <Link
                      className={`nav-link ${cl}`}
                      style={{
                        animation: 0,
                        marginTop: 2,
                        padding: '5px 10px'
                      }}
                      onClick={regulamentoClick}
                      type="button"
                    >{name}</Link>
                  );
                }
              })
            } */}
          </nav>
        </header>
      </React.Fragment>
    );
  }
}